import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { Button, useBooleanState } from '@retailer-platform/shared-components'
import { useParams } from 'react-router'
import FilterBar from 'legacy/components/FilterBar'
import { useGoToPath } from 'utils/routing/navigation.hooks'
import { type HeroBannerQueryParams } from 'domains/merchandising/types/heroBanner.types'
import { useDashMessages } from 'intl/intl.hooks'
import { HeroBannerDeleteModal } from './HeroBannerDeleteModal'

interface Props {
  placementName: string
}

const filterContainer = css({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
})

export const HeroBannerDetailsSecondaryNav: FunctionComponent<Props> = ({ placementName }) => {
  const { heroBannerId } = useParams<HeroBannerQueryParams>()

  const [modalOpen, showModal, hideModal] = useBooleanState(false)

  const goToEditPage = useGoToPath('merchandising-hero-banners-edit', {
    heroBannerId,
  })

  const messages = useDashMessages({
    editButton: 'merchandising.hero-banners.details.button.edit',
    deleteButton: 'merchandising.hero-banners.details.button.delete',
    confirmTitle: 'merchandising.hero-banners.details.deleteModal.title',
  })

  return (
    <FilterBar padding="0 20px">
      <div css={filterContainer}>
        <div>
          <Button onClick={showModal} variant="detrimental">
            {messages.deleteButton}
          </Button>
          <Button onClick={goToEditPage}>{messages.editButton}</Button>
        </div>
      </div>
      <HeroBannerDeleteModal
        heroBannerId={heroBannerId}
        heroBannerName={placementName}
        isOpen={modalOpen}
        onCancel={hideModal}
      />
    </FilterBar>
  )
}
